// extracted by mini-css-extract-plugin
module.exports = {"Navbar":"NavigationItems_Navbar__37EUD","NavigationItems":"NavigationItems_NavigationItems__1fnFX"};